import styled from 'styled-components';
import colors from 'Styles/colors';

const Icon = styled.div`
  user-select: none;
  display: inline-block;
  position: relative;
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.background};
  text-align: center;
  font-size: 20px;
  color: ${colors.white};
  text-transform: uppercase;
  flex-shrink: 0;
`;
Icon.displayName = 'Icon';

export const IndicatorDot = styled.span`
  position: absolute;
  top: -1px;
  right: -1px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.buttons.primary.background};
  ${({ borderColor }) => borderColor && `border: 2px solid ${borderColor};`}
  pointer-events: none;
`;
IndicatorDot.displayName = 'IndicatorDot';

export default Icon;
